/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Alipay_EnabledInputs */

const en_admin_settings_fields_alipay_enabled = /** @type {(inputs: Admin_Settings_Fields_Alipay_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Alipay`)
};

/**
* | output |
* | --- |
* | "Enable Alipay" |
*
* @param {Admin_Settings_Fields_Alipay_EnabledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_alipay_enabled = /** @type {((inputs?: Admin_Settings_Fields_Alipay_EnabledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Alipay_EnabledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_alipay_enabled(inputs)
});
export { admin_settings_fields_alipay_enabled as "admin.settings.fields.alipay_enabled" }